
export class camion_sucursalJoin {
	public patente: string;
	public sucursal_codigo: number;
	public rut_empresa: number;
	public fecha_asignacion: Date;
	public activo: boolean;
	public descripcion:string;
	public peso_maximo:number;
	public volumen:number;
	public fecha_creacion:Date;
	public listaCamionUnidadNegocio: Array<any> = [];
	public rut_chofer:number;
}
